module.exports = __webpack_public_path__ + "img/1080_05.0ea77460.jpg";